import React from 'react';

import {AttachTooltip} from 'app/general/overlays';
import {gt} from 'app/utils/i18n';

import {FolderLink} from './FolderLink';

import {
  BasicFolderSerializedType,
  ConnectionFieldSerializedType,
} from 'sweet-types';

type Props = {
  connections?: Array<ConnectionFieldSerializedType>;
  showNoEditMessage?: boolean;
};

export const DocumentFoldersList = ({
  connections,
  showNoEditMessage = false,
}: Props) => {
  if (connections == null || connections.length === 0) {
    return null;
  }

  // a no-duplicate list of folders.
  const folders: Array<BasicFolderSerializedType> = connections.reduce(
    (
      result: Array<BasicFolderSerializedType>,
      connection: ConnectionFieldSerializedType
    ) => {
      let folder: BasicFolderSerializedType;

      if (
        connection.folder == null ||
        connection.process != null ||
        connection.team != null
      ) {
        return result;
      } else {
        folder = connection.folder;
      }

      if (result.map((f) => f.hashid).indexOf(folder.hashid) === -1) {
        result.push(folder);
      }
      return result;
    },
    []
  );

  const list = folders.map((folder) => (
    <span key={folder.hashid}>
      <FolderLink
        name={folder.name}
        hashid={folder.hashid}
        html_url={folder.html_url}
        className="badge badge-secondary"
        icon={true}
      />{' '}
    </span>
  ));

  return (
    <div className="form-group">
      {showNoEditMessage ? (
        <AttachTooltip
          placement="bottom"
          tooltipContent={gt('Only managers can edit folders')}
        >
          {(handlers) => <span {...handlers}>{list}</span>}
        </AttachTooltip>
      ) : (
        list
      )}
    </div>
  );
};
